package games.mythical.saga.watcher.sagawatcher.frontend.layout

import csstype.ident

object Area {
    val Header = ident("header")
    val Sidebar = ident("sidebar")
    val Content = ident("content")
}
